import { TouchableOpacity, Linking } from "react-native";
import { white_smoke } from "../../StyleHelpers";
import H4 from "../Typography/H4";
import H5 from "../Typography/H5";
import Image from "../Image/Image";
import External from "../../assets/Icons/External.svg";
import { LabelProps } from "./model";
import { IconImage, StyledChildMargin, StyledContainer, StyledFooterContainer, StyledMainContainer, StyledText } from "./styled";

const LabelContainer = ({
	header,
	subHeader,
	onClickableBody,
	onPressSubHeader,
	imageSource,
	isIcon,
	disableIcon,
	addMarginChild,
	body,
	onPressBody,
	footer,
	onClickableFooter,
	onPressFooter,
	isFooterIcon,
}: LabelProps) => {
	const handleFooterIconPress = () => {
		if (footer) Linking.openURL(footer);
	};

	/**
	 * Renders a subheader element. If `onClickableBody` is true,
	 * the subheader is wrapped in a `TouchableOpacity` to make it clickable,
	 * otherwise, it renders as a plain `H4` component.
	 *
	 * @returns {JSX.Element | null} - The rendered subheader or null if `subHeader` is not provided.
	 */
	const renderSubHeader = () => {
		if (!subHeader) return null;

		if (onClickableBody) {
			return (
				<TouchableOpacity onPress={onPressSubHeader}>
					<H4 fontColor={white_smoke}>{subHeader}</H4>
				</TouchableOpacity>
			);
		}

		return <H4 fontColor={white_smoke}>{subHeader}</H4>;
	};

	/**
	 * Renders the body content. If `onClickableBody` is true,
	 * the body is wrapped in a `TouchableOpacity` to make it clickable.
	 * Otherwise, it renders as a plain `H5` component.
	 *
	 * @returns {JSX.Element | null} - The rendered body or null if `body` is not provided.
	 */
	const renderBody = () => {
		if (!body) return null;

		return onClickableBody ? (
			<TouchableOpacity onPress={onPressBody}>
				<H5 fontColor={white_smoke}>{body}</H5>
			</TouchableOpacity>
		) : (
			<H5 fontColor={white_smoke}>{body}</H5>
		);
	};

	/**
	 * Renders the footer content. If `onClickableFooter` is true,
	 * it wraps the footer text (and optionally an icon) inside a styled container with clickable elements.
	 * If `isFooterIcon` is also true, an icon is rendered alongside the footer text.
	 * Otherwise, it renders as a plain `H5` component.
	 *
	 * @returns {JSX.Element | null} - The rendered footer or null if `footer` is not provided.
	 */
	const renderFooter = () => {
		if (!footer) return null;

		if (onClickableFooter) {
			return (
				//@ts-ignore
				<StyledFooterContainer>
					<TouchableOpacity onPress={onPressFooter}>
						<H5 fontColor={white_smoke}>{footer}</H5>
					</TouchableOpacity>
					{isFooterIcon ? (
						<TouchableOpacity onPress={handleFooterIconPress}>
							<Image source={{ uri: External }} width={40} height={40} />
						</TouchableOpacity>
					) : (
						<></>
					)}
				</StyledFooterContainer>
			);
		}

		return <H5 fontColor={white_smoke}>{footer}</H5>;
	};

	return (
		//@ts-ignore
		<StyledContainer>
			{/* @ts-ignore */}
			<StyledText>
				{/* @ts-ignore */}
				<StyledMainContainer>
					<H4>
						{header}
						{renderSubHeader()}
					</H4>

					{imageSource && !disableIcon ? (
						//@ts-ignore
						<IconImage>
							<Image source={{ uri: imageSource }} style={isIcon ? { width: 40, height: 40 } : { width: 67.4, height: 31.7 }} />
						</IconImage>
					) : (
						<></>
					)}
				</StyledMainContainer>
			</StyledText>
			{/* @ts-ignore */}
			<StyledChildMargin addMarginChild={addMarginChild}>
				{renderBody()}
				{renderFooter()}
			</StyledChildMargin>
		</StyledContainer>
	);
};

export default LabelContainer;
